module.exports = __webpack_public_path__ + "static/img/bg_9.ae50806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_9.png
// module id = B7SV
// module chunks = 1